<div class="flex mx-auto justify-center items-center bg-white border border-[#DAE1E4] rounded-full p-1 w-max {{extraClass}}">

    <!-- English -->
    <span
        class="lng-toggle"
        [class.bg-[#0059FF]]="currentLang === 'en'" [class.text-white]="currentLang === 'en'"
        [class.text-var[(--text-primary)]]="currentLang !== 'en'" (click)="setLang('en')">
        ENG
    </span>

    <!-- Toggle Switch -->
    <input type="checkbox" class="toggle-checkbox hidden" [checked]="currentLang === 'ar'" (change)="toggleLang()" />

    <!-- Arabic -->
    <span
        class="lng-toggle"
        [class.bg-[#0059FF]]="currentLang === 'ar'" [class.text-white]="currentLang === 'ar'" dir="rtl" lang="ar"
        [class.text-var[(--text-primary)]]="currentLang !== 'ar'" (click)="setLang('ar')">
        عربي
    </span>
</div>